import React from "react";
import { graphql } from "gatsby";
import LayoutComponent from "../components/global/layout";
import SEOComponent from "../components/global/seo";
import NoteIndexListingComponent from "../components/notes/note-index-listing";

const NoteListingLayout = ({ data, pageContext }) => {
  const { allMarkdownRemark } = data;
  
  let metaDescription = "Half baked ideas, ramblings, thoughts that are too long for a tweet and too short for a blog post.";

  if (pageContext.currentPage > 1) {
    metaDescription = `Page ${pageContext.currentPage} of noteworthy ramblings written by Surinder Bhomra.`
  }

  return (
    <LayoutComponent>
      <SEOComponent 
        title={`Notes${(pageContext.currentPage > 1 ? ` - Page ${pageContext.currentPage}` : "")}`}
        metaDescription={metaDescription}
        shareImageIsLarge={true} />
      <div className="divide-y">
        <header className="pt-6 pb-8 space-y-2 md:space-y-5">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            Notes
          </h1>
          <p>Half baked ideas, ramblings, thoughts that are too long for a tweet and too short for a blog post.</p>
        </header>
        <NoteIndexListingComponent data={allMarkdownRemark} path="/Notes" pageContext={pageContext} />
      </div>
    </LayoutComponent>
  )
}

export default NoteListingLayout

export const query = graphql`
  query noteList($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { type: { eq: "note" }} },
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          html
          frontmatter {
            title
            summary
            date
            externalSourceUrl
          }
        }
      }
    }
  }
`